import { Paper } from '@material-ui/core';
import React from 'react';
import ApprovalsTable from './ApprovalsTable';

interface Props {
    approvalDecisions: any[];
}

function ApprovalsPanel(props: Props) {
    const { approvalDecisions } = props;

    return (
        <Paper>
            <ApprovalsTable actions={approvalDecisions} />
        </Paper>
    );
};

export default ApprovalsPanel;
